/** @module csi/table/QuerySizeController */
define([
	"dojo/_base/declare",
	"csi/view/QuerySizeController"
], function(declare,QuerySizeController) {

	return declare(QuerySizeController, {
		progressTopic: "/csi/table/expand",

		/**
		 * Display progess dialog if auto-expanding
		 */
		process: function() {
			if (this.widget.getAutoExpandLevel()) {
				this.displayProgressDialog({
					closable: false,
					progressValue: 0
				});
			}
			
			this.inherited(arguments);
		}
	});
});